import axios from 'axios';

export const getMonitorJobsApi = async () => {
  const response = await axios.get('/admin/monitor/jobs');
  return response.data;
};

export const getMonitorTypesApi = async () => {
  const response = await axios.get('/admin/monitor/types');
  return response.data;
};

export const createMonitorJobApi = async (data) => {
  const response = await axios.post('/admin/monitor/jobs', data);
  return response.data;
};

export const updateMonitorJobApi = async ({ jobId, ...data }) => {
  const response = await axios.put(`/admin/monitor/jobs/${jobId}`, data);
  return response.data;
};

export const deleteMonitorJobApi = async ({ jobId }) => {
  await axios.delete(`/admin/monitor/jobs/${jobId}`);
};

export const toggleMonitorJobApi = async ({ jobId, isEnabled }) => {
  await axios.put(`/admin/monitor/jobs/${jobId}/toggle`, { isEnabled });
};

export const getMonitorJobLogsApi = async ({ jobId }) => {
  const response = await axios.get(`/admin/monitor/jobs/${jobId}/logs`);
  return response.data;
};
